/* Change Color / Change Size inline in cart drawer — field + dropdown UI */
(function () {
  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { cache[handle] = p; return p; });
  }
  function currentVariant(product, variantId) {
    for (var i = 0; i < product.variants.length; i++) if (product.variants[i].id == variantId) return product.variants[i];
    return null;
  }
  function findVariant(product, opts) {
    return product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === opts[i]; });
    });
  }
  function labels(es) {
    return es
      ? { select: 'Elegir', update: 'Actualizar', cancel: 'Cancelar', updating: 'Actualizando…', unavailable: 'No disponible', error: 'Error' }
      : { select: 'Select', update: 'Update Item', cancel: 'Cancel', updating: 'Updating…', unavailable: 'Unavailable', error: 'Error' };
  }
  var CHEV = '<svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';

  function closePanels(except) {
    document.querySelectorAll('.cvs-panel').forEach(function (p) { if (p !== except) p.remove(); });
  }
  function closeDropdowns() {
    document.querySelectorAll('.cvs-dd').forEach(function (d) { d.remove(); });
    document.querySelectorAll('.cvs-field.open').forEach(function (f) { f.classList.remove('open'); });
  }

  async function refreshDrawer() {
    var res = await fetch(window.routes ? routes.cart_url + '?section_id=cart-drawer' : '/?section_id=cart-drawer');
    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['cart-drawer-items', '.drawer__footer', '#CartDrawer-CartItems', '.cart-drawer__footer'].forEach(function (sel) {
      var nw = doc.querySelector(sel), cur = document.querySelector(sel);
      if (nw && cur) cur.replaceWith(nw);
    });
    var b = doc.querySelector('#cart-icon-bubble') || doc.querySelector('.cart-count-bubble');
    var cb = document.querySelector('#cart-icon-bubble') || document.querySelector('.cart-count-bubble');
    if (b && cb) cb.innerHTML = b.innerHTML;
    if (window.striderBoot) window.striderBoot();
  }

  function thumbFor(product, cv, optIndex, val) {
    var testOpts = cv.options.slice(); testOpts[optIndex] = val;
    var match = findVariant(product, testOpts);
    var img = (match && match.featured_image && match.featured_image.src) || null;
    return { match: match, img: img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_60x60$1$2') : null };
  }

  function fieldValueHTML(isColor, img, val) {
    var h = '<span class="cvs-field__val">';
    if (isColor && img) h += '<img src="' + img + '" alt="">';
    h += '<span>' + val + '</span></span>';
    return h + CHEV;
  }

  async function openPanel(link) {
    var wrap = link.closest('[data-cvs]');
    if (!wrap) return;
    var existing = wrap.parentNode.querySelector('.cvs-panel');
    if (existing && existing.dataset.for === link.dataset.cvsOpen) { existing.remove(); return; }
    closePanels();
    var handle = wrap.dataset.handle, variantId = wrap.dataset.variant, qty = wrap.dataset.qty, key = wrap.dataset.key;
    var es = wrap.dataset.es === '1';
    var L = labels(es);
    var optName = link.dataset.cvsOpen;
    var product = await getProduct(handle);
    var cv = currentVariant(product, variantId);
    if (!cv) return;
    var optIndex = product.options.map(function (o) { return (o.name || o).toLowerCase(); }).indexOf(optName.toLowerCase());
    if (optIndex < 0) optIndex = 0;
    var isColor = /colou?r/i.test(optName);

    // unique values in product order
    var seen = {}, values = [];
    product.variants.forEach(function (v) { var val = v.options[optIndex]; if (!seen[val]) { seen[val] = 1; values.push(val); } });

    var selected = cv.options[optIndex];

    var panel = document.createElement('div');
    panel.className = 'cvs-panel'; panel.dataset.for = optName;
    var title = document.createElement('p'); title.className = 'cvs-title'; title.textContent = L.select + ' ' + optName; panel.appendChild(title);

    var ddwrap = document.createElement('div'); ddwrap.className = 'cvs-ddwrap';
    var field = document.createElement('button'); field.type = 'button'; field.className = 'cvs-field';
    var curThumb = thumbFor(product, cv, optIndex, selected);
    field.innerHTML = fieldValueHTML(isColor, curThumb.img, selected);
    ddwrap.appendChild(field);
    panel.appendChild(ddwrap);

    field.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = ddwrap.querySelector('.cvs-dd');
      closeDropdowns();
      if (open) return;
      var dd = document.createElement('div'); dd.className = 'cvs-dd';
      values.forEach(function (val) {
        var t = thumbFor(product, cv, optIndex, val);
        var row = document.createElement('button'); row.type = 'button';
        row.className = 'cvs-dd__row' + (val === selected ? ' is-sel' : '') + (t.match && t.match.available ? '' : ' is-un');
        if (isColor && t.img) row.innerHTML = '<img src="' + t.img + '" alt=""><span>' + val + '</span>';
        else row.innerHTML = '<span>' + val + '</span>';
        row.addEventListener('click', function (e2) {
          e2.stopPropagation();
          selected = val;
          field.innerHTML = fieldValueHTML(isColor, t.img, val);
          field.classList.remove('open');
          dd.remove();
        });
        dd.appendChild(row);
      });
      ddwrap.appendChild(dd);
      field.classList.add('open');
    });

    var actions = document.createElement('div'); actions.className = 'cvs-actions';
    var upd = document.createElement('button'); upd.type = 'button'; upd.className = 'cvs-update'; upd.textContent = L.update;
    var cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'cvs-cancel'; cancel.textContent = L.cancel;
    cancel.addEventListener('click', function () { panel.remove(); });
    upd.addEventListener('click', async function () {
      var newOpts = cv.options.slice(); newOpts[optIndex] = selected;
      var target = findVariant(product, newOpts);
      if (!target || !target.available) { upd.textContent = L.unavailable; return; }
      if (target.id == variantId) { panel.remove(); return; }
      upd.textContent = L.updating; upd.disabled = true;
      try {
        /* read the live line item to preserve app properties (e.g. Kaching __moonbundle) and selling plan — dropping them makes the bundle app revert the swap */
        var cartNow = await (await fetch('/cart.js')).json();
        var line = cartNow.items.find(function (i) { return i.key === key; });
        var addItem = { id: target.id, quantity: line ? line.quantity : (Number(qty) || 1) };
        if (line && line.properties && Object.keys(line.properties).length) addItem.properties = line.properties;
        if (line && line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) addItem.selling_plan = line.selling_plan_allocation.selling_plan.id;
        /* add first, then remove the old line — never lose the item if one call fails */
        var addRes = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [addItem] }) });
        if (!addRes.ok) throw new Error('add failed');
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
        await refreshDrawer();
      } catch (e) { upd.textContent = L.error; upd.disabled = false; }
    });
    actions.appendChild(upd); actions.appendChild(cancel); panel.appendChild(actions);
    wrap.parentNode.appendChild(panel);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-cvs-open]');
    if (link) { e.preventDefault(); openPanel(link); return; }
    if (!e.target.closest || !e.target.closest('.cvs-ddwrap')) closeDropdowns();
  });
})();
